import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../layout/layout';
import { useTheme } from '@mui/material/styles';
import { Box, Paper, Typography, Dialog, DialogContent } from '@mui/material';
import TvIcon from '@mui/icons-material/Tv';
import { motion } from 'framer-motion';
import { useSelectedProvider } from "../services/selectedProiderContext";
import { useAuth } from '../services/authContext';
import AccountSelector from "./AccountSelector";
import { hasPermission, hasAction } from '../Utils/role';

// Reusable Card Component (NO popup logic here)
const DashboardCard = ({ icon, title, description, color, onClick }) => {
  return (
    <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
      <Paper
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          borderRadius: 2,
          boxShadow: 3,
          bgcolor: color,
          cursor: 'pointer',
          height: "155px",
          width: '100%',
        }}
        onClick={onClick}
      >
        <Box sx={{ mb: 1 }}>{icon}</Box>
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
        <Typography variant="body2">
          {description}
        </Typography>
      </Paper>
    </motion.div>
  );
};

const Dashboard = ({ toggleTheme }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { selectedProvider } = useSelectedProvider();
  const { user } = useAuth();
  
  // 1. RBAC Utilities (No more legacy userRole string matching)
  const isSuperAdmin = hasPermission("IS_SUPER_ADMIN");
  const canCreateResource = hasAction("CREATE_RESOURCE");

  const [openProviderDialog, setOpenProviderDialog] = useState(false);

  useEffect(() => {
    const justLoggedIn = sessionStorage.getItem("justLoggedIn");
    const activeAccountId = sessionStorage.getItem("activeAccountId");
    const isAccountMissing = !activeAccountId || activeAccountId === "null" || activeAccountId === "undefined";
      
    // 2. Safely evaluate and clear local storage based on flags
    if (justLoggedIn === "true" || isAccountMissing) {
      sessionStorage.removeItem("justLoggedIn"); // Clean up flag here
      sessionStorage.removeItem("activeAccountId");
      localStorage.removeItem("selectedProvider");
      localStorage.removeItem("selectedProjectId");
      setOpenProviderDialog(true);
    } else if (!canCreateResource && !isSuperAdmin) {
      navigate('/Resources', { replace: true });
    }
  }, [isSuperAdmin, canCreateResource, navigate]);

  const dashboardNew = () => {
    localStorage.setItem('catalogueSelection', 'New');
    setOpenProviderDialog(true);
  };
 
  return (
    <Layout pageType="sideBar" toggleTheme={toggleTheme}>
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ width: '48%' }}>
          
          {canCreateResource && (
            <DashboardCard
              color={theme.palette.background.header}
              icon={<TvIcon sx={{ color: theme.palette.primary.main }} />}
              title="New Resource"
              description="Create Resource Request"
              onClick={dashboardNew}
            />
          )}
          
        </Box>
      </Box>

      <Dialog
        open={openProviderDialog}
        disableEscapeKeyDown
        fullScreen
        slotProps={{
          paper: {
            sx: { m: 5, height: '80vh', overflow: "hidden", borderRadius: 1 }
          },
          backdrop: {
            sx: { backgroundColor: 'rgba(0, 0, 0, 0.7) !important' } 
          }
        }}
        onClose={(e, reason) => {
          if (reason === "backdropClick") return;
        }}
      >
        <DialogContent sx={{overflow: "hidden",}}>
          <AccountSelector onSuccess={() => setOpenProviderDialog(false)} />
        </DialogContent>
      </Dialog>
    </Layout>
  );
};

export default Dashboard;